<template>
  <span class='window-container'>

    <span @click='open'>
      <i class="fa fa-eye"></i>
    </span>

    <div :class="['backdrop', isOpen ? 'backdrop-open' : '']">
    </div>

    <div :class="['window', isOpen ? 'window-open' : '']">

        <div class="window-header">

          <template v-for="(action, key) in actions">

            <button v-if='showActionButton(action)' :key='key' class="btn btn-default" @click='executeAction(action)'>
              <img :src="iconPath(action.icon)" alt="" class='action-icon'>
              {{ action.command_name }}
            </button>

          </template>

          <button
            v-if="canAttachScanCopy && application.status === 'awaiting_signing'" @click='approveApplication'
            class='btn btn-default btn-expand'
            :disabled='application.scanCopiesUrls.length === 0'
          >
            Подать без КЭП
          </button>

          <button v-if='canIssuePasses(application)' @click='issuePasses(application)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/pass.svg`" alt="" class='action-icon'>
            Выдать пропуска по заявке
          </button>

          <button v-if='canPrintDefaultPasses(application)' @click='issuePasses(application)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/pass.svg`" alt="" class='action-icon'>
            Распечатать пропуска по заявке
          </button>

          <button v-if='canPrintPassesPermanentAsOne(application)' @click='issuePasses(application, true)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/pass.svg`" alt="" class='action-icon'>
            Распечатать разовые пропуска по заявке
          </button>

          <button v-if='canPrintPassesPermanent(application)' @click='issuePasses(application)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/pass.svg`" alt="" class='action-icon'>
            Распечатать постоянные пропуска по заявке
          </button>

          <button v-if="application.showSendSolvo && user && user.role === 'sb'" @click='sendSolvoXml(application.id)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/v_solvo.svg`" alt="" class='action-icon'>
            Передать в Solvo.TOS
          </button>

          <button v-if='canSendToScud(application)' @click='sendApplicationScud(application)' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/v_scud.svg`" alt="" class='action-icon'>
            Передать в скуд
          </button>

          <button v-if='canAttachScanCopy(application)' @click='openAttachScanCopy' class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/scan.svg`" alt="" class='action-icon'>
            Приложить скан-копию
          </button>

          <a v-if='canDuplicate(application)' :href="url('duplicate_id', application.id, '#new')" class='btn btn-default'>
            <img :src="`${baseUrl}/img/icons/statuses/copy.svg`" alt="" class='action-icon'>
            Дублировать
          </a>

          <button @click='close' type="button" class="btn btn-default btn-close close-window-btn" aria-label="Close">
            <span aria-hidden="true" class='close-icon'>&times;</span>
          </button>

          <div class='application-status-indicator' :style='{backgroundColor: applicationStatus.bg_color}'>
            {{ applicationStatus.name }}
          </div>

        </div>

        <div v-if='canShowInternalComment' :class="['horizontal-field', addInternalCommentMargin ? 'internal-comment' : '']">

          <div class="field-label">
            Служебный комментарий:
          </div>

          <div class="input-group">

            <input v-model='internalComment' type="text" class='form-control internal-comment-input'/>

            <div
              @click="internalComment !== null && internalComment !== '' ? internalComment = '' : null"
              :class="['input-group-addon', internalComment !== null && internalComment !== '' ? 'btn clear-comment-btn' : '']"
            >
              Очистить
            </div>

          </div>
        </div>

        <div class="window-title">

          <div class="horizontal-field">
            <div class="field-label">
              Обращение (заявка):
            </div>

            <div>
              <span @click='openApplicationData' :class="!showApplicationData ? 'clickable' : ''">
                №{{ application.number }}
              </span> на {{ passType }} {{ passPeriod }} <span class='field-label'>от Пользователя:</span>

              <span :class="!showUserData ? 'clickable' : ''" @click='openUserData'> {{ application.user.email }}</span>

            </div>

          </div>

        </div>

        <div class="centered-fields">

          <div class="centered-fields-label">Заявитель:</div>

          <div
            :class="!showOrganizationData ? 'clickable' : ''"
            @click='openOrganizationData'
          >
            {{ application.organization.short_name || application.organization.name }}
          </div>

          <div class="centered-fields-label">
            Подписант:
          </div>

          <div>
            {{ application.organization.position_of_manager }} {{ application.organization.director_name }}
          </div>

        </div>

        <div class='tabs'>

          <div class="tabs-header">

            <div class="field-label">
              {{ !isApplicationAuto ? 'Посетители:' : 'Транспорт:' }}
            </div>

            <div class="tabs-row">

              <template v-if="!isApplicationAuto">

                <div
                  v-for='(visitor, index) in visitors'
                  :class="['tab',
                    currentTab == index ? 'tab-active' : '',
                    visitor.access == 1 ? 'tab-blocked' : ''
                  ]"
                  :key='visitor.personal.id'
                  @click='setTab(index)'
                >

                  <div class="tab-text">
                    {{ visitor.personal.fullname_last }}
                  </div>

                </div>

              </template>
              <template v-if="isApplicationAuto">

                <div
                  v-for='(transport, index) in transports'
                  :key='transport.id'
                  :class="['tab',
                    currentTransportIndex === index ? 'tab-active' : '',
                    transport.access == 1 ? 'tab-blocked' : '',
                    transport.trailer !== '' ? 'marquee' : ''
                  ]"
                  @click='selectTransport(index, transport.files)'
                >

                  <div
                    :class="['tab-text', transport.trailer !== '' ? 'marquee-inner' : '']"
                    :title="tabTitle(transport)"
                  >

                    <div
                      class='transport-tab-text'
                    >
                      <img :src="`${baseUrl}/img/icons/${transport.numberNationality.iso2}.svg`" alt="" class='transport-nationality-icon'>
                      {{ transport.number !== '' ? transport.number : 'ГРЗ отсутствует' }}
                      <div v-if='transport.trailer'>/</div>
                      <img v-if='transport.trailer' :src="`${baseUrl}/img/icons/${transport.trailerNationality.iso2}.svg`" alt="" class='transport-nationality-icon'/>
                      {{ transport.trailer !== '' ? ` ${transport.trailer}` : '' }}
                    </div>

                    <transport-action-menu
                      v-if='currentTransportIndex === index'
                      :visitor='transportVisitor'
                      :transport='transport'
                      :cfg-menu-visitor='cfgMenuVisitor'
                      :cfg-menu-transport='cfgMenuTransport'
                      @issue-pass='(transport) => issuePass(transportVisitor, transport)'
                      @change-transport-access='changeTransportAccess'
                      @give-pdf-pass='(isGivePassPeriod, printPermanentAsOne) => givePdfPass(isGivePassPeriod, printPermanentAsOne, transportVisitor, index)'
                    />
                  </div>

                </div>

              </template>

            </div>

          </div>

          <div v-if='isLoadingVisitors' class='visitor-loader'>
            <div class="visitor-loader-indicator"></div>
          </div>

          <div class="tabs-content">

            <div :class="['tabs-content-left', isApplicationAuto && !showApplicationData && !showOrganizationData && !showUserData ? 'tabs-content-left-inverse' : '']">

              <application-data
                v-if='showApplicationData'
                :base-url='baseUrl'
                :application='application'
                :cfg-form-fields='cfgFormFields'
              />

              <organization-data
                v-if='showOrganizationData'
                :application='application'
              />

              <attach-scan-copy
                v-if='showAttachScanCopy'
                :application='application'
                :base-url='baseUrl'
                @attach-scan-copy='addScanCopy'
              />

              <user-data v-if='showUserData' :application-user='application.user'/>

              <div v-if='isApplicationAuto ? currentTransportIndex !== null : currentVisitor' :class="['col visitor-gap', isApplicationAuto ? 'application-auto-visitor' : '']">

                <div v-if="isApplicationAuto" class="tabs-header">

                  <div class="field-label">
                    Посетители:
                  </div>

                  <div class="tabs-row">

                    <div
                      v-for='(visitor, index) in isApplicationAuto ? currentTransportDrivers : visitors'
                      :class="['tab',
                        currentTab == index ? 'tab-active' : '',
                        visitor.access == 1 ? 'tab-blocked' : ''
                      ]"
                      :key='visitor.id'
                      @click='setTab(index)'
                    >

                      <div class="tab-text">
                        {{ visitor.personal.fullname_last }}
                      </div>

                    </div>

                  </div>

                </div>

                <visitor-data
                  v-if='!isApplicationAuto ? currentVisitor : currentTab !== null'
                  :base-url='baseUrl'
                  :visitor='currentVisitor'
                  :cfg-form-fields='cfgFormFields'
                  :cfg-menu-visitor='cfgMenuVisitor'
                  @change-visitor-access='changeVisitorAccess'
                  @issue-pass='issuePass'
                  @give-pdf-pass='(isGivePassPeriod, printPermanentAsOne, visitor) => givePdfPass(isGivePassPeriod, printPermanentAsOne, visitor)'
                />

              </div>

              <application-stages-of-approval
                v-if='showApplicationData'
                :stages='application.logs.list'
              />

              <visitor-transports
                v-if="!isApplicationAuto ? currentVisitor : currentTransportIndex !== null"
                :base-url='baseUrl'
                :transports="!isApplicationAuto ? currentVisitorTransports : transports"
                :current-transport-index='currentTransportIndex'
                :is-application-auto='isApplicationAuto'
                :cfg-menu-visitor='cfgMenuVisitor'
                :cfg-menu-transport='cfgMenuTransport'
                :cfg-form-fields='cfgFormFields'
                :visitor='currentVisitor'
                :tab-title='tabTitle'
                @select-transport='selectTransport'
                @issue-pass='(transport) => issuePass(currentVisitor, transport)'
                @change-transport-access='changeTransportAccess'
                @give-pdf-pass='(isGivePassPeriod, printPermanentAsOne, transportIndex) => givePdfPass(isGivePassPeriod, printPermanentAsOne, currentVisitor, transportIndex)'
              />

            </div>

            <div class="tabs-content-right">

              <document-view
                :base-url='baseUrl'
                :files='previewFiles'
              />

              <document-list
                ref='documentList'
                :documents='documents'
                :set-files='setFiles'
                :nationality-documents='nationalityDocuments'
                :application-documents='applicationDocuments'
                :transport-documents='transportDocuments'
                :application='application'
                :visitor='currentVisitor'
                :transport='currentTransport'
                :is-current-documents-transport='currentTransportIndex !== null'
                :is-application-auto='isApplicationAuto'
                :is-application-documents='showApplicationData'
                :is-organization-documents='showOrganizationData'
                :show-attach-scan-copy='showAttachScanCopy'
                :show-user-data='showUserData'
              />

            </div>

            <div v-if='showOrganizationData || showUserData'></div>

          </div>

          <div class="vertical-field">

            <div class="field-label">
              Комментарий для пользователя
            </div>

            <div class="input-group">
              <input v-model='comment' :disabled="disabledCommentInput" class='form-control comment-input'/>

              <div
                v-if='!disabledCommentInput'
                @click="comment !== null && comment !== '' ? comment = '' : null"
                :class="['input-group-addon',
                  comment !== null && comment !== '' ? 'btn clear-comment-btn' : ''
                ]"
              >
                Очистить
              </div>

            </div>

          </div>

        </div>

      </div>
  </span>
</template>

<script>
import moment from 'moment';
import { BaseApiClient } from '../../../helpers/BaseApiClient';
import { ApiClient } from '@/helpers/api-client/ApiClient';
import VisitorData from './VisitorData.vue';
import VisitorTransports from './VisitorTransports.vue';
import ApplicationData from './ApplicationData.vue';
import UserData from './UserData.vue';
import DocumentView from './DocumentView.vue';
import DocumentList from './DocumentList.vue';
import OrganizationData from './OrganizationData.vue';
import permissionsMixin from '@/common/mixins/PermissionsMixin';
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses';
import { UserRoles } from '@/common/enums/UserRoles';
import PermissionsEnum from '@/common/enums/PermissionsEnum';
import ApplicationStagesOfApproval from './ApplicationStagesOfApproval.vue';
import TransportActionMenu from './menu/TransportActionMenu.vue';
import AttachScanCopy from './AttachScanCopy.vue';
import { PassKinds } from '../../../enums/PassKinds';
export default {

  mixins: [permissionsMixin],

  components: {
    VisitorData,
    VisitorTransports,
    ApplicationData,
    UserData,
    DocumentView,
    DocumentList,
    OrganizationData,
    ApplicationStagesOfApproval,
    TransportActionMenu,
    AttachScanCopy
  },

  props: {
    applicationIndex: {
      type: Number
    },

    baseUrl: {
      type: String
    },

    application: {
      type: Object
    },

    approvalCommand: {
      type: Function
    },

    getSigner: {
      type: Function
    },

    statuses: {
      type: Array,
      required: true
    },

    canIssuePasses: {
      type: Function,
      required: true
    },

    canPrintDefaultPasses: {
      type: Function,
      required: true
    },

    canPrintPassesPermanentAsOne: {
      type: Function,
      required: true
    },

    canPrintPassesPermanent: {
      type: Function,
      required: true
    },

    canSendToScud: {
      type: Function,
      required: true
    },

    canDuplicate: {
      type: Function,
      required: true
    },

    canAttachScanCopy: {
      type: Function,
      required: true
    },

    issuePasses: {
      type: Function,
      required: true
    },

    sendApplicationScud: {
      type: Function,
      required: true
    },

    sendSolvoXml: {
      type: Function,
      required: true
    },

    setApplicationVisitorsCloseCount: {
      type: Function,
      required: true
    },

    setApplicationScanCopies: {
      type: Function,
      required: true
    },

    url: {
      type: Function,
      required: true
    },

    cfgFormFields: {
      type: Object,
      required: true
    },

    nationalityDocuments: {
      type: Array,
      required: true
    },

    applicationDocuments: {
      type: Array,
      required: true
    },

    transportDocuments: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      visitors: [],
      currentTab: null,
      currentDocumentKey: null,
      currentTransportIndex: null,
      transports: [],
      transportVisitor: {},
      documents: this.getApplicationDocuments(),
      comment: this.application.comment,
      internalComment: this.application.internal_comment,
      previewFiles: null,
      applicationPdfs: [],
      isOpen: false,
      isVisitorsFetched: false,
      isLoadingVisitors: false,
      showApplicationData: true,
      showOrganizationData: false,
      showUserData: false,
      showAttachScanCopy: false,
      cfgMenuVisitor: null,
      cfgMenuTransport: null
    }
  },

  computed: {
    applicationStatus() {
      const status = this.statuses.find((status) => status.id === this.application.status)

      return status
    },

    addInternalCommentMargin() {
      return this.actions.length === 0 && !this.canIssuePasses(this.application) && !this.canPrintDefaultPasses(this.application) &&
        !this.canPrintPassesPermanentAsOne(this.application) && !this.canPrintPassesPermanent(this.application) &&
        !this.canPrintPassesPermanent(this.application) && !this.canSendToScud(this.application) && !this.canDuplicate(this.application)
    },

    visitorsPersonalsCount() {
      return this.application.visitorsCount
    },

    actions() {
      let actions = []
      for (const actionName in this.application.statusActions) {
        const action = this.application.statusActions[actionName]
        if (this.showActionButton(action)) {
          actions.push(action)
        }
      }

      return actions
    },

    isApplicationAuto() {
      return this.application.pass_kind === 'transport'
    },

    currentVisitor() {
      if (this.isApplicationAuto) return this.currentTransportDrivers[this.currentTab]
      return this.visitors[this.currentTab]
    },

    currentVisitorTransports() {
      return this.currentVisitor.transports.filter((t) => t.type !== 'pedestrian')
    },

    currentTransport() {
      if (this.isApplicationAuto && this.transports.length !== 0) return this.transports[this.currentTransportIndex]

      if (this.currentVisitor) {
        return this.currentVisitorTransports[this.currentTransportIndex]
      }

      return null
    },

    currentTransportDrivers() {
      if (!this.isApplicationAuto) return []

      return this.visitors.filter((visitor) => visitor.transports[0] === this.transports[this.currentTransportIndex])
    },

    canShowInternalComment() {
      return this.hasPermission(PermissionsEnum.canUseInternalComment)
    },

    equalSubdivisions() {
      let applicationSubdivisionId = this.application.subdivision_id
      if (![null, undefined].includes(applicationSubdivisionId)) {
        applicationSubdivisionId = parseInt(applicationSubdivisionId)
      }

      return Boolean(this.user.subdivisions.find(subdivisionId => parseInt(subdivisionId) === applicationSubdivisionId))
    },

    passType() {
      return `${this.application.time_type === 'permanent' ? 'Постоянный' : 'Разовый'} пропуск`
    },

    passPeriod() {
      if (this.application.time_type === 'permanent') {
        return `с ${moment(this.application.period_of).format('DD.MM.YYYY')} по ${moment(this.application.period_to).format('DD.MM.YYYY')}`
      }

      return `с ${moment(this.application.period_of).format('DD.MM.YYYY')} по ${moment(this.application.period_to).format('DD.MM.YYYY')}`
    },

    disabledCommentInput () {
      return [
        ApplicationStatuses.FSB_NO,
        ApplicationStatuses.SB_NO,
        ApplicationStatuses.FSB_YES,
        ApplicationStatuses.FSB_BEGIN
      ].includes(this.application.status) || this.actions.length === 0 || this.user.role === UserRoles.USER
    }
  },

  methods: {
    addScanCopy(files) {
      if (files.length === 0) this.setApplicationScanCopies(files, this.application)

      const formatedFiles = files.map((file) => ({
        mediaType: file.meta.type.includes('image') ? 'image' : 'iframe',
        src: `${this.baseUrl}/get-file/scan-copy?filename=${file.meta.name}&applicationId=${this.application.id}`
      }))

      this.setApplicationScanCopies(formatedFiles, this.application)
    },

    showActionButton(action) {
      return Boolean(
        this.checkActionOwner(action) &&
        this.checkActionSubdivision(action) &&
        this.checkActionClosedVisitors(action)
      )
    },

    checkActionSubdivision(action) {
      return parseInt(action.check_subdivision) === 0 ||
        (parseInt(action.check_subdivision) === 1 && this.equalSubdivisions)
    },

    checkActionOwner(action) {
      return action.check_owner === 'all' ||
        (action.check_owner === 'own' && parseInt(this.application.user_id) === parseInt(this.user.id)) ||
        (action.check_owner === 'other' && parseInt(this.application.user_id) !== parseInt(this.user.id))
    },

    checkActionClosedPersonals(action) {
      return parseInt(action.check_closed_users) === 0 || (
        parseInt(action.check_closed_users) === 1 &&
        this.application.visitorsCloseCount !== this.visitorsPersonalsCount
      )
    },

    checkActionClosedTransports(action) {
      return parseInt(action.check_closed_transports) === 0 || (
        parseInt(action.check_closed_transports) === 1 &&
        this.application.transportsCloseCount !== this.application.transportsCount
      )
    },

    checkActionClosedVisitors(action) {
      if (this.application.pass_kind === PassKinds.TRANSPORT) {
        return this.checkActionClosedTransports(action)
      } else {
        return this.checkActionClosedPersonals(action)
      }
    },

    tabTitle(transport) {
      const transportNumber = transport.number !== '' ? transport.number : 'ГРЗ отсутствует'
      const trailerInfo = transport.trailer !== '' ? `/ ${transport.trailerNationality.full_name} ${transport.trailer}` : ''
      return `${transport.numberNationality.full_name} ${transportNumber} ${trailerInfo}`
    },

    iconPath(iconName) {
      return `${this.baseUrl}/img/icons/statuses/${iconName}`
    },

    executeAction(item) {
      return item.esignature === '1'
        ? this.getSigner(this.application, item)
        : this.approvalCommand(this.application, item, this.applicationIndex, this.comment)
    },

    getDocuments() {
      if (Array.isArray(this.application.applicationDocuments)) return {}

      return this.application.applicationDocuments
    },

    getFirstKey(object) {
      const documents = Object.keys(object)
      return documents[0]
    },

    getApplicationDocuments() {
      const { egrul, egrip, ...documents } = this.getDocuments()
      return documents
    },

    getOrganizationDocuments() {
      const { egrul, egrip } = this.getDocuments()

      return this.application.organization.subject_id !== 'individual' ? { egrul } : { egrip }
    },

    setFiles(files) {
      this.previewFiles = files
    },

    setDocumentPreviewForCurrentVisitor() {
      this.$refs.documentList.resetDocumentList()
      this.documents = this.currentVisitor.files
    },

    setDocumentPreviewForOrganization() {
      this.documents = this.getOrganizationDocuments()
    },

    setTransportDocuments(documents) {
      this.documents = documents
    },

    setDocumentPreviewForApplication() {
      this.documents = this.getApplicationDocuments()
      this.applicationPdfs.forEach((pdf, index) => {
        this.documents = {
          [`pdf${index + 1}`]: [
            {
              mediaType: 'iframe',
              src: pdf[2]
            }
          ],
          ...this.documents
        }
      })

      if (this.application.scanCopiesUrls.length !== 0) {
        this.documents = {
          scanCopy: this.application.scanCopiesUrls,
          ...this.documents
        }
      }
    },

    selectTransport(index, documents) {
      if (this.application.pass_kind === 'transport') {
        this.showApplicationData = false
        this.showUserData = false
        this.showOrganizationData = false
        this.currentTab = null
      }
      this.currentTransportIndex = index
      this.setTransportDocuments(documents)
    },

    setTab(tab) {
      this.currentDocumentKey = null
      this.showApplicationData = false
      this.showOrganizationData = false
      this.showUserData = false
      this.showAttachScanCopy = false
      this.currentTab = tab

      if (!this.isApplicationAuto) {
        this.currentTransportIndex = null
      }

      this.setDocumentPreviewForCurrentVisitor()
    },

    resetTabs() {
      if (this.isApplicationAuto) {
        this.currentTransportIndex = null
      }
      this.currentTab = null
      this.previewFiles = null
      this.currentDocumentKey = null
      this.$refs.documentList.resetDocumentList()
    },

    open() {
      this.isOpen = true
      const pdfMatchs = [...this.application.pdf.matchAll(/href=([\\"])(.*?)\1/gm)]

      const filteredPdfMatchs = pdfMatchs.filter((match) => match[2] !== '#')

      const formatedPdfMatchs = filteredPdfMatchs.map((match) => {
        match[2] = match[2].replaceAll('amp;', '')

        return match
      })

      this.applicationPdfs = [...formatedPdfMatchs]

      this.setDocumentPreviewForApplication()
      document.querySelector('html').classList.add('hidden-scroll')
      if (!this.isVisitorsFetched) {
        this.fetchVisitors()
      }

      if (!this.cfgMenuVisitor) {
        this.fetchCfgMenuVisitor()
      }

      if (!this.cfgMenuTransport) {
        this.fetchCfgMenuTransport()
      }
    },

    close() {
      this.isOpen = false
      this.currentTab = null
      this.currentTransportIndex = null
      this.showOrganizationData = false
      this.showUserData = false
      this.showApplicationData = true
      this.setDocumentPreviewForApplication()
      document.querySelector('html').classList.remove('hidden-scroll')
    },

    openApplicationData() {
      this.resetTabs()
      this.showUserData = false
      this.showOrganizationData = false
      this.showAttachScanCopy = false
      this.showApplicationData = true
      this.setDocumentPreviewForApplication()
    },

    openOrganizationData() {
      this.resetTabs()
      this.showApplicationData = false
      this.showUserData = false
      this.showAttachScanCopy = false
      this.showOrganizationData = true
      this.setDocumentPreviewForOrganization()
    },

    openUserData() {
      this.resetTabs()
      this.showApplicationData = false
      this.showOrganizationData = false
      this.showAttachScanCopy = false
      this.showUserData = true
      this.documents = {}
    },

    openAttachScanCopy() {
      this.resetTabs()
      this.showApplicationData = false
      this.showOrganizationData = false
      this.showUserData = false
      this.showAttachScanCopy = true
      this.previewFiles = null
      this.$refs.documentList.resetDocumentList()
    },

    formatVisitorsData(data) {
      let formatedVisitorsData = []
      let transports = []
      let transportVisitor = {}
      data.forEach((visitor) => {
        transportVisitor = visitor
        visitor.transports.forEach((transport) => {
          transports.push(transport)
          if (transport.drivers.length !== 0) {
            transport.drivers.forEach((driver) => {
              formatedVisitorsData.push({
                ...driver,
                transports: [transport]
              })
            })
          }
        })
      })

      this.visitors = formatedVisitorsData
      this.transports = transports
      this.transportVisitor = transportVisitor
    },

    async changeVisitorAccess(visitor) {
      const { data } = await ApiClient.changeVisitorAccess({
        visitor_id: visitor.personal,
        appId: this.application.id
      })

      if (data.status === 'success') {
        let newVisitorsCloseCount = this.application.visitorsCloseCount

        if (visitor.access) {
          newVisitorsCloseCount -= 1
        } else {
          newVisitorsCloseCount += 1
        }

        this.setApplicationVisitorsCloseCount(newVisitorsCloseCount)

        visitor.access = visitor.access ? 0 : 1

        if (!this.isApplicationAuto) {
          visitor.transports.forEach((transport) => {
            transport.access = visitor.access
          })
        }
      }
    },

    async changeTransportAccess(transport) {
      let personalId

      if (this.isApplicationAuto) {
        personalId = this.transportVisitor.personal.id
      } else {
        personalId = this.currentVisitor.personal.id
      }

      const { data } = await ApiClient.changeTransportAccess({
        application_id: this.application.id,
        transport_id: transport,
        visitor_id: personalId
      })

      if (data.status === 'success') {
        transport.access = transport.access ? 0 : 1

        if (this.isApplicationAuto) {
          console.log(this.currentTransportDrivers)
          this.currentTransportDrivers.forEach((driver) => {
            driver.access = transport.access
          })
        }
      }
    },

    async issuePass(visitor, transport) {
      const { data } = await ApiClient.issuePass({
        visitor_id: visitor.personal.id,
        appId: this.application.id,
        transportId: transport?.id
      })
      if (data.status === 'success') {
        if (transport) {
          transport.isIssued = true
        } else {
          console.log(visitor.personal)
          visitor.personal.isIssued = true
        }
        this.givePdfPass(this.isGivePassPeriod, false, visitor)
      }
    },

    async givePdfPass(isGivePassPeriod, printPermanentAsOne, visitor, transportIndex) {
      const pdfPassBlobResponse = await ApiClient.getPass(
        this.application.id,
        visitor.personal.id,
        visitor.transports[transportIndex]?.id ?? '',
        isGivePassPeriod ?? false,
        printPermanentAsOne ?? false
      )
      this.openPdfInNewTab(pdfPassBlobResponse.data)
    },

    async fetchVisitors() {
      this.isLoadingVisitors = true
      const { data } = await BaseApiClient.get('application/visitors', {
        params: {
          applicationId: this.application.id
        },
        headers: BaseApiClient.getAuthHeaders()
      })

      if (this.application.pass_kind === 'transport') {
        this.formatVisitorsData(data.data)

        this.isVisitorsFetched = true

        this.isLoadingVisitors = false

        return
      }

      this.visitors = data.data
      this.isVisitorsFetched = true
      this.isLoadingVisitors = false
    },

    async fetchCfgMenuVisitor() {
      const { data } = await ApiClient.cfgMenuData({
        id: this.application.id,
        type: 'visitor'
      })

      if (data.status === 'success') {
        this.cfgMenuVisitor = data.data
      }
    },

    async fetchCfgMenuTransport() {
      const { data } = await ApiClient.cfgMenuData({
        id: this.application.id,
        type: 'transport'
      })

      if (data.status === 'success') {
        this.cfgMenuTransport = data.data
      }
    },

    async approveApplication() {
      this.showAttachScanCopy = false
      this.showApplicationData = true
      const approveAction = this.actions.find((action) => Boolean(action.for_approval) === true)

      if (approveAction) {
        await this.approvalCommand(this.application, approveAction, this.applicationIndex)
      }
    }
  }
}
</script>

<style>
.hidden-scroll {
  overflow: hidden;
}
.window-container{
  padding: 0 4px;
}
.backdrop{
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1030;
}
.backdrop-open{
  display: flex;
}

.backdrop-open:hover{
  background-color: rgba(255, 0, 0, 0.2);
}

.window {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 1328px;
  width: 80%;
  height: 80%;
  background: white;
  border-radius: 8px;
  padding: 32px;
  display: none;
  flex-direction: column;
  gap: 16px;
  z-index: 1032;
  transform: translate(-50%, -50%);
}

.window-open{
  display: flex;
}

.window-header{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.window-title {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tabs{
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tabs-header{
  display: flex;
  align-items: center;
  gap: 16px;
}

.tabs-row {
  display: flex;
  align-items: center;
  flex: 1;
  overflow-x: auto;
}

.tab{
  min-width: 200px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  color: #337ab7;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  transform: skewX(-20deg);
}

.tab-text{
  display: flex;
  align-items: center;
  gap: 16px;
  transform: skewX(20deg);
}

.tab-text > .dropdown > button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: transparent;
  padding: 4px;
  margin: 0;
  border-radius: 50%;
  color: #337ab7;
}

.tab-text > .dropdown > button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.tab-text > .dropdown > button:active {
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: none;
}

.tab-blocked {
  background-color: rgba(255, 0, 0, 0.1);
}

.tab-active {
  color: black;
  border-right: 1px solid #337ab7;
  border-bottom: 1px solid #337ab7;
}

.tabs-content{
  height: 100%;
  padding: 16px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  overflow-y: auto;
}

.tabs-content-left, .tabs-content-right {
  display: grid;
  grid-template-rows: 492px 140px;
  gap: 16px;
}

.tabs-content-left-inverse {
  grid-template-rows: 140px 492px !important;
}

.horizontal-field{
  display: flex;
  align-items: center;
  gap: 8px;
}

.vertical-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.centered-fields {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 16px;
  margin: 0 auto;
}

.centered-fields-label {
  display: flex;
  justify-content: end;
}

.field-label, .centered-fields-label{
  color: rgba(0, 0, 0, 0.5);
}

.data-row{
  display: flex;
  align-items: center;
}

.col {
  display: flex;
  flex-direction: column;
}

.visitor-loader{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.visitor-loader-indicator {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top: 2px solid #337ab7;
  animation: visitor-loading .5s linear infinite;
}

.visitor-gap {
  gap: 16px;
}

.action-icon {
  width: 20px;
  height: 22px;
}

.close-icon {
  display: flex;
  align-items: center;
  height: 24px;
  font-size: 24px;
}

.clickable {
  color: #337ab7;
}

.close-window-btn {
  position: absolute;
  top: 0;
  right: 0;
  margin: 32px;
}

.comment {
  resize: none;
}

.hide-extra-text{
  max-width: 480px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.clear-comment-btn{
  background-color: transparent !important;
  color: #337ab7 !important;
}

.internal-comment {
  margin-top: 48px;
}

.internal-comment-input {
  width: 100px;
}

.comment-input:not(:disabled), .internal-comment-input {
  border-color: #337ab7 !important;
}

.application-status-indicator {
  width: 525px;
  position: absolute;
  top: -80px;
  left: -50px;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 32px;
  font-size: 28px;
}

.application-auto-visitor {
  grid-row: 2 / 3;
  grid-column: 1 / 2;
}

.btn-expand {
  height: 100%;
}

@keyframes visitor-loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
